import { MerchantListItem } from "@/types";
import { MerchantState } from "./index";

export default {
  setMerchantList(state: MerchantState, payload: MerchantListItem[]) {
    state.merchantList = payload;
  },
};
